var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"office-divisions"},[_c('store-product',{attrs:{"data_products":_vm.data_products}}),_c('main-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }